import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { DatasAtoSemEfeito } from '../../core/services/analise-processo.service';

@Component({
  standalone: true,
  selector: 'app-datas-ato-sem-efeito-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  template: `
    <h2 mat-dialog-title>Adicionar Datas Ato Sem Efeito</h2>
    <form [formGroup]="form" (ngSubmit)="salvar()">
      <mat-dialog-content class="conteudo">
        <div class="linha">
          <mat-form-field appearance="outline">
            <mat-label>Data do ato</mat-label>
            <input matInput type="date" formControlName="dataAto" required />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Data Publicação</mat-label>
            <input matInput type="date" formControlName="dataPublicacao" required />
          </mat-form-field>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancelar()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
          Salvar
        </button>
      </mat-dialog-actions>
    </form>
  `,
  styles: [
    `
      .conteudo {
        min-width: 420px;
      }
      .linha {
        display: flex;
        gap: 1rem;

        mat-form-field {
          flex: 1;
        }
      }
    `,
  ],
})
export class DatasAtoSemEfeitoDialogComponent {
  public form: FormGroup;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private dados: DatasAtoSemEfeito | null,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DatasAtoSemEfeitoDialogComponent, DatasAtoSemEfeito | null>
  ) {
    this.form = this.fb.group({
      dataAto: [dados?.dataAto ?? '', Validators.required],
      dataPublicacao: [dados?.dataPublicacao ?? '', Validators.required],
    });
  }

  public salvar(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value);
  }

  public cancelar(): void {
    this.dialogRef.close(null);
  }
}
